export default __webpack_public_path__ + "static/media/gallery_03.02ce342c.jpg";